const TextInput = ({
    label,
    name,
    value,
    onChange,
    type = "text",
    isRequired = false,
    disabled = false,
    min,
    maxLength,
    inputMode,
    placeholder,
    step,
    isPriceInput = false
}) => {
    return (
        <div>
            {label && (
                <label className="block text-sm font-medium text-gray-700">
                    {label} {isRequired && <span className="text-red-500">*</span>}
                </label>
            )}

            <input
                type={type}
                name={name}
                value={value || ""}
                onChange={onChange}
                disabled={disabled}
                required={isRequired}
                // maxLength={maxLength}
                inputMode={inputMode}
                pattern={isPriceInput ? "^\\d+(\\.\\d{1,3})?$" : undefined}
                placeholder={placeholder}
                step={step}
                min={min !== undefined ? min : undefined} 
                className="mt-1 py-[5px] px-[10px] block w-full border border-gray-200 rounded-md shadow-sm focus:ring-brand-red focus:border-brand-red"
            />
        </div>
    );
};

export default TextInput;
